// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"R5-z"};